import { gql } from '@apollo/client';

export const PROJECT_CONTRIBUTOR_FRAGMENT = gql`
  fragment ProjectContributorFragment on ProjectContributorInterface {
    id
    databaseId
    webURL
    name
    avatar
    initials
    companyId
    companyName
  }
`;

export const PROJECT_FEATURED_PHOTO_FRAGMENT = gql`
  fragment ProjectFeaturedPhotoFragment on Project {
    __typename
    id
    featuredPhoto {
      __typename
      id
      annotatedUris(variants: [THUMBNAIL, MEDIUM, ORIGINAL]) {
        variant
        uri
      }
    }
  }
`;

export const ASSET_FEED_ITEM_FRAGMENT = gql`
  fragment AssetFeedItemFragment on AssetFeedItem {
    id
    databaseId
    accentColor
    assetPreviewThumbnail
    assetPreviewLarge
    capturedAt
    internal
    contributor {
      ... on ProjectContributorInterface {
        ...ProjectContributorFragment
      }
    }
    projectInfo {
      id
      databaseId
      formattedLine1
      formattedLine2
    }
  }

  ${PROJECT_CONTRIBUTOR_FRAGMENT}
`;

export const ASSET_FEED_ITEM_PHOTO_FRAGMENT = gql`
  fragment AssetFeedItemPhotoFragment on Photo {
    hasDescription
    metadata
    internal
    annotatedUris(variants: [ORIGINAL, MEDIUM, THUMBNAIL]) {
      __typename
      variant
      uri
    }
    originalUris(variants: [ORIGINAL, MEDIUM, THUMBNAIL]) {
      __typename
      variant
      uri
    }
  }
`;

export const ASSET_FEED_ITEM_VIDEO_FRAGMENT = gql`
  fragment AssetFeedItemVideoFragment on Video {
    hasDescription
    playbackUrl
    durationSeconds
  }
`;
